module.exports = __webpack_public_path__ + "static/media/b0ndi.0dbc7f1b.svg";